import login from "../i18n/en/Login"

export default {
  login,
  "home": {
    "deviceState": "Device State",
    "totalAuthorized": "Total Authorized",
    "beAuthorized": "Authorized",
    "onLine": "Online",
    "offLine": "Offline",
    "taskState": "Task State",
    "totalProgram": "Total Programs",
    "approve": "Approved",
    "reject": "Rejected",
    "unreviewed": "Unreviewed",
    "MaterialStatistics": "Material Statistics",
    "img": "Image",
    "video": "Video",
    "frequency": "Audio",
    "doc": "Document",
    "systeminfo": "System Info",
    "totalMemory": "Total Memory",
    "USED": "Used",
    "residue": "Remaining",
    "platform": "Platforms",
    "individual": "Items"
  },

  "terminal": {
    "deviceState": "Device State",
    "deviceglTitle": "Device Management",
    "DeviceProperties": "Device Properties",
    "device": {
      "MBFree": "Remaining Capacity",
      "deviceState": "State",
      "deviceName": "Name",
      "devicenumber": "Number",
      "deviceRAM": "Memory",
      "deviceID": "ID",
      "deviceMAC": "MAC",
      "screenNumber": "Screen Number",
      "deviceLshoocation": "Location",
      "AUTHORISE": "Authorized",
      "beAuthorized": "Authorized",
      "unauthorized": "Unauthorized",
      "resolution": "Resolution",
      "remarks": "Remarks",
      "deviceIP": "IP",
      "sysversion": "Sys Version",
      "ViewTask": "View Task",
      "offlineTime": "Offline Duration",
      "onofftime": "On/Off Time",
      "uptime": "Uptime",
      "offTime": "Off Time",
      "Mon": "Mon",
      "Tues": "Tue",
      "Wednes": "Wed",
      "Thurs": "Thur",
      "Fri": "Fri",
      "Satur": "Sat",
      "sun": "Sun",
      "a_key_phone": "One-click Alarm Phone",
      "operation": "Operation",
      "type": "Type",
      "taskName": "Task Name",
      "dutyCycle": "Duty Cycle",
      "startTime": "Start Time",
      "endTime": "End Time",
      "dateline": "Send Time",
      "ClearExpired": "Clear Expired",
      "starttime": "Start Date",
      "endtime": "End Date",
      "sbjc": "Device Check",
      "sbjcz": "Checking Device",
      "successfully": "Success",
      "fairly": "Failure",
      "serverIp": "Server IP"
    },
    "command": "Remote Command",
    "control": "Remote Monitoring",
    "setting": "Settings",
    "upgradeTitle": "Remote Upgrade",
    "upgrade": {
      "fileType": "Type",
      "fileName": "File Name",
      "versionNum": "Software Version",
      "versionName": "Software Package Name",
      "sysversion": "System Version",
      "upTime": "Upload Time",
      "serialName": "Serial Number",
      "facilityID": "Device ID",
      "deviceName": "Device Name",
      "downSeed": "Speed",
      "downprogress": "Progress",
      "downState": "State",
      "eliminate": "Clear",
      "inquire": "Inquire",
      "Upgrademanagement": "Upgrade Management",
      "UpgradeList": "Upgrade List",
      "Upgradeequipment": "Upgrade Device",
      "speed": "Speed",
      "progress": "Progress",
      "remote": "Remote Monitoring",
      "Interface": "Fetching Interface",
      "preview": "Double-click to Preview Image",
      "interface": "Monitoring Interface"
    },
    "StatisticsTitle": "Display Statistics",
    "Statistics": {
      "fileName": "File Name",
      "preview": "Preview",
      "type": "Type",
      "number": "Count",
      "statistical": "Statistical Duration",
      "operation": "Operation",
      "a": "Devices"
    },
    "registrationTitle": "Device Registration",
    "registration": {
      "icon": "Icon",
      "facilityID": "Device ID",
      "facilityIP": "Device IP"
    },
    "instruct": {
      "volume": "Volume",
      "restart": "Restart",
      "rouse": "Wake Up",
      "sleep": "Sleep",
      "shutdown": "Shutdown",
      "qlds": "Clear Schedule",
      "qlcp": "Clear Disk",
      "qlrw": "Clear Task",
      "LoadingTitle": "Issuing Command",
      "titlemini": "Issuing Command",
      "adjust": "Adjust Volume"
    },
    "flow": {
      "flow": "Flow",
      "diagramName": "Monthly Flow Chart",
      "chart": "Hourly Flow Chart",
      "Daily": "Daily Flow Chart",
      "tip": "Click the bar chart for details"
    },
    "deviceList": "Device List"
  },

  "program": {
    "company": "Company Name",
    "Screeningstate": "Screening State",
    "verified": "Verified",
    "refuse": "Not Verified",
    "unreviewed": "Unreviewed",
    "unused": "Unused",
    "bytesUsed": "Used",
    "qsrjmmc": "Please Enter Program Name",
    "program": "Program",
    "programType": "Program Type",
    "tasks": "Bound Tasks",
    "resolution": "Resolution",
    "hdjm": "Interactive Program",
    "xxcb": "Message Insertion",
    "ptjm": "Regular Program",
    "width": "Width",
    "height": "Height",
    "task": "Program Group",
    "qxzwj": "Please Select Program Category",
    "create": "Create Now",
    "addResolution": "Add Resolution",
    "programName": "Program Name",
    "auditstatus": "Audit Status",
    "onstate": "Usage Status",
    "guanlian": "Associated Tasks",
    "pass": "Pass",
    "refusea": "Reject",
    "cjjm": "Create Program",
    "scenesetting": "Scene Setting",
    "sceneTime": "Scene Time",
    "bgImg": "Background Image",
    "top": "Top Margin",
    "left": "Left Margin",
    "jmcj": "Program Scene",
    "addbg": "Add Background Image",
    "selesc": "Selected Materials",
    "adddecive": "Add Device",
    "selecteddevice": "Selected Devices",
    "review": "Program Review",
    "xgfz": "Modify Group",
    "audit": "Audit",
    "template": "Template List",
    "move": "Move",
    "delcontrol": "Delete Control",
    "full": "Full Screen Display",
    "addsucai": "Add Material",
    "sticky": "Pin to Top",
    "Bottom": "Pin to Bottom",
    "ascend": "Move Up",
    "descend": "Move Down",
    "DaemonTime": "Daemon Time",
    "VideoDisplayType": "Video Display Type",
    "ImageDisplayType": "Image Display Type",
    "DualConfiguration": "Dual Screen Configuration",
    "FullStretch": "Full Stretch",
    "GeometricScaling": "Geometric Scaling",
    "FullDisplay": "Original Size Display",
    "reverse": "Interface Reverse",
    "MandatoryAdaptation": "Mandatory Adaptation",
    "Software": "Effective on Software Restart",
    "qbccj": "Please Save Scene",
    "addImage": "Add Image",
    "addMixture": "Add Mixed Playback",
    "addVideo": "Add Video",
    "addAudio": "Add Audio",
    "addDoc": "Add Document",
    "default_effect": "Default Effect",
    "right_to_left": "Right to Left",
    "left_to_right": "Left to Right",
    "top_to_bottom": "Top to Bottom",
    "bottom_to_top": "Bottom to Top",
    "accordion_squeeze": "Accordion Squeeze",
    "zoom_in_gradient": "Zoom In Gradient",
    "zoom_out_gradient": "Zoom Out Gradient",
    "rotate_in": "3D Rotate In",
    "rotate_out": "3D Rotate Out",
    "field_gradient": "Field Gradient",
    "Left_right_rotation": "Left-Right Rotation",
    "up_and_down_rotation": "Up-Down Rotation",
    "counter_clockwise_rotation": "Counter-Clockwise Rotation",
    "clockwise_rotation": "Clockwise Rotation",
    "zoom_up_and_down": "Zoom Up and Down",
    "frame_effect": "3D Frame Effect",
    "scale_gradient": "Scale Gradient",
    "zoom_in_on": "Zoom In Fade Animation",
    "transparent_gradient": "Transparent Gradient",
    "gradient_scaling": "Gradient Scaling",
    "upper_left_corner": "Upper Left Corner",
    "center_top": "Center Top",
    "upper_right_corner": "Upper Right Corner",
    "center_left": "Center Left",
    "center": "Center",
    "center_right": "Center Right",
    "lower_left_corner": "Lower Left Corner",
    "bottom_center": "Bottom Center",
    "lower_right_corner": "Lower Right Corner",
    "copy": "Copy",
    "ckhz": "Swap Width and Height",
    "display": "Display Type",
    "screen": "Screen Type",
    "proportion": "Proportion",
    "refresh_time": "Refresh Time",
    "count_down": "Countdown",
    "is_timing": "Positive timing",
    "timing": "Timing type",
  },

  "task": {
    "createTask": "Create Task",
    "tasktype": "Task Type",
    "bindingProgram": "Bind Program",
    "releaseTask": "Release Task",
    "addTask": "Add Task",
    "TaskName": "Task Name",
    "Playmode": "Play Mode",
    "ReplaceMode": "Replace Mode",
    "Spotpatterns": "Insert Mode",
    "simulcastingmode": "Synchronous Mode",
    "AppendMode": "Append Mode",
    "TaskGroup": "Task Group",
    "Broadcast": "Broadcast Cycle",
    "Continue": "Continuous Play",
    "broadcasting": "Scheduled Play",
    "newlyTask": "New Task",
    "management": "Task Management",
    "DownloadList": "Download List",
    "timehorizon": "Time Range",
    "information": "Program Information",
    "playback": "Playback Cycle",
    "Completed": "Completed",
    "unfinished": "Unfinished",
    "ptrw": "Regular Task",
    "sprw": "Dual Screen Task",
    "pmlx": "Screen Category",
    "zmcb": "Subtitle Insert",
    "jmfbl": "Program Resolution",
    "total": "Total",
    "cycle": "Effective Cycle",
    "daterange": "Date Range",
    "Editingtasks": "Edit Task",
    "ptlx": "Regular Type",
    "splx": "Dual Screen Type",
    "hdlx": "Interactive Type",
    "size": "Task Size",
    "interactive": "Interactive Task",
    "addprogram": "Add Program",
    "equipment": "View Equipment",
    "deletask": "Delete Task",
    "taskimprom": "Export Task",
    "downloadsu": "Download Successful",
    "downloading": "Downloading",
    "Waiting_download": "Waiting to Download",
    "task_list": "Task List",
    "selectDate": "Task Cycle"
  },

  "system": {
    "serverSettings": "Server Settings",
    "thresholdSettings": "Set Memory Threshold",
    "maxspeed": "Maximum Download Speed",
    "maxnumber": "Maximum Download Devices",
    "Memory": "Memory Cleanup Level",
    "ncql": "Memory Cleanup Level",
    "yldh": "Reserved Alarm Phone",
    "configuration": "To ensure smooth server operation, please check the configuration information",
    "unit": "Unit",
    "Reserved": "Reserved Alarm Phone",
    "maxmin": "Suggested Maximum Download Devices Less Than",
    "custom": "Feel Free to Set",
    "management": "Role Management",
    "phoneNumber": "Phone Number",
    "nickName": "Nickname",
    "creationTime": "Creation Time",
    "operation": "Operation",
    "log": "Log Management",
    "Module": "Module Name",
    "action": "Action",
    "operationType": "Operation Type",
    "newUsers": "New Users",
    "contact": "Contact Information",
    "Review": "Review Permissions",
    "confirmPassword": "Confirm Password",
    "dualIp": "Operation IP",
    "userName": "Username",
    "time": "Time",
    "qxzkssj": "Please Select Start Time",
    "qxzjs": "Please Select End Time",
    "qxzmode": "Please Select Module Name",
    "runningLog": "Running Log",
    "operationLog": "Operation Log",
    "logPS": "Note: Export server running error logs",
    "sysHelp": "System Help",
    "Formatspecification": "Format Specification",
    "fileFormat": "File Format",
    "imgFormat": "Image Format",
    "audioFormat": "Audio Format",
    "videoFormat": "Video Format",
    "softwareVersion": "Software Version",
    "backup": "Data Backup",
    "instructions": "Instructions",
    "derivePS": "Please click the export button to backup the database before updating the version",
    "versionsPS": "After updating the version, re-enter this page in the publishing system, click the import button and select the file exported by the above export button",
    "basicSetting": "Basic Settings",
    "iscompress": "Compress on Upload",
    "isstatistics": "Enable Statistics",
    "fileSize": "Upload Size Limit",
    "bjdhkg": "Alarm Phone",
    "yes": "Yes",
    "no": "No",
    "wbgs": "Text Format",
    "maximum": "Maximum Value",
    "Uploadconfiguration": "Basic Settings",
    "broadband": "Broadband",
    "addrole": "Add Role",
    "updated": "Update Date",
    "details": "Update Details",
    "customset": "Custom Settings",
    "Wallpaper": "Wallpaper Upload",
    "landscape": "Landscape",
    "PorTrait": "Portrait",
    "xgsbyh": "Transfer Device",
    "default": "Clear Wallpaper",
    "logout": "Terminal Logout Password",
    "ps": "Please Enter User Login Account",
    "port": "Port Number",
    "ad": "Current Task (Yellow icon for replace mode, orange icon for append mode, red icon for insert mode, blue icon for sync mode, pink icon for schedule mode)",
    "exsetsing": "USB Registration",
    "upan": "USB Operations",
    "qjyl": "Interval Volume",
    "tzyl": "Adjust Volume",
    "assist": "Please contact after-sales for assistance with this operation",
    "role_email": "Email",
    "login_email": "Please Enter Email"
  },

  "management": {
    "open_authorization": "Authorize Platform Account Opening",
    "open_call": "Alarm Call",
    "dredge": "Open",
    "essential": "Basic Information",
    "CustomerName": "Customer Name",
    "Authorization": "Authorized Devices",
    "capacity": "Space Capacity",
    "userState": "User Status",
    "address": "Customer Address",
    "Account": "Account Period",
    "servercapacity": "Server Capacity",
    "Addcustomer": "Add Customer",
    "phone": "Customer Account",
    "Pass": "Password",
    "ConfirmPass": "Confirm Password",
    "name": "Name/Company Name",
    "adder": "Address",
    "effective": "Effective Date",
    "serverPix": "Server Capacity Must Be a Multiple of 100",
    "Customer": "Customer Account",
    "onlineNum": "Offline Devices",
    "offLineNum": "Online Devices",
    "Customeraddress": "Customer Address",
    "deleclient": "Delete Customer",
    "distribution": "Distribute Devices",
    "xgkyrl": "Modify Available Capacity",
    "sqsbts": "Authorized Devices",
    "gross": "Total",
    "used": "Used",
    "Editrole": "Edit Role",
    "rejection": "Rejection Reason",
    "qdql": "Light Cleanup (Delete Program Information)",
    "zdql": "Moderate Cleanup (Delete All Large Media Files in Memory)",
    "gdql": "High Cleanup (Format SD Card)",
    "exerrlog": "Export Error Log",
    "exdelog": "Export Log",
    "download_speed": "Download Speed Limit",
    "serverrate": "Download Speed Must Not Exceed",
    "editcustomer": "Edit Customer",
    "addcustomer": "Add Customer",
    "abcd": "Please Enter Username/Phone Number",
    "activation": "Activation",
    "recharge": "Recharge",
    "description": "Order Description",
    "number": "Order Number",
    "amount": "Order Amount",
    "status": "Order Status",
    "charge": "Remaining Balance",
    "wzf": "Unpaid",
    "yzf": "Paid",
    "credit": "Recharge Amount",
    "dollar": "Yuan",
    "payable": "Payable Amount",
    "pay": "Pay",
    "gratuitous": "No Bonus",
    "f30": "Bonus 30 Yuan",
    "f10": "Bonus 10 Yuan",
    "export_code": "Export Authorization Code",
    "expiration_time": "Expiration Time",
    "ps": "This activation code is valid for the day and cannot be reused",
    "export_file": "Import File",
    "average_flow": "Average Traffic",
    "cus_phone": "Phone Number",
    "email": "Email",
    "cus_email": "Customer Email"
  },
  "getCode": "Get Verification Code",
  "usercenter": "User Center",
  "LogOff": "Log Off",
  "account": "Account",
  "editpassword": "Change Password",
  "edituser": "Edit User",
  "phone": "Phone",

  "uspix": "Account can only be a combination of letters, numbers, or alphanumeric",
  "oldPass": "Old Password",
  "newPass": "New Password",
  "ConfirmPass": "Confirm Password",
  "package": "Installation Package",
  "WordDOC": "Word Document",
  "videoDetails": "Video Details",
  'Material': 'Material',
  'Program': 'Program',
  'Task': 'Task',
  'Settings': 'Deploy',
  'Terminal': 'Terminal',
  'Manage': 'Manage',
  'immediately': 'Immediately change',
  "lang": "English",
  "zh": "Chinese",
  "en": "English",
  "version": "Version",
  "customer": "Edit Customer",
  "download": "Download",
  "watching": "Watch Online",
  "download_again": "Download Again",
  "select_device": "Select Device",
  "prev": "Previous Page",
  "next": "Next Page",
  "day": "Day",
  "tsfm": "Days Hours Minutes Seconds",
  "month": "Month",

  "material": {
    "name": "Material Name",
    "materialType": "Material Type",
    "state": "Status",
    "fileSize": "File Size",
    "scupload": "Material Upload",
    "zzscdsl": "Number of Uploads in Progress",
    "updata": "Upload",
    "abortUpdata": "Abort Upload",
    "upfairly": "Upload Failed",
    "uploaded": "Upload Complete",
    "Boundmaterial": "Bound Material",
    "Boundpo": "Bound Program",
    "upch": "Upload Successful",
    "material_group": "Material Group"
  },

  "btns": {
    "confirm": "Confirm",
    "newgroup": "New Group",
    "cancel": "Cancel",
    "submit": "Submit",
    "creation": "Create",
    "export": "Export",
    "importing": "Import",
    "delete": "Delete",
    "rename": "Rename",
    "alldelete": "Batch Delete",
    "send": "Send",
    "mainScreen": "Main Screen",
    "viceScreen": "Secondary Screen",
    "preview": "Preview",
    "add": "Add",
    "save": "Save",
    "removeAll": "Clear All",
    "clearaway": "Clear",
    "clearCompleted": "Clear Completed",
    "remove": "Clear All at Once",
    "refresh": "Refresh",
    "search": "Search",
    "upgradeEquipment": "Upgrade Equipment",
    "Editversion": "Edit Version Number",
    "inquire": "Inquire",
    "examine": "View",
    "examineuser": "View User",
    "Retrieve": "Retrieve Device",
    "AKregister": "One-Click Register",
    "edit": "Edit",
    "reset": "Reset",
    "all": "All",
    "EmptyCanvas": "Clear Canvas",
    "movegrouping": "Move Group",
    "uploadFiles": "Upload Files",
    "newProgram": "New Program",
    "Akeytoempty": "One-Click Clear",
    "addrole": "Add Role",
    "enabled": "Enable",
    "disable": "Disable",
    "clickupload": "Click to Upload",
    "next": "Next Step",
    "back": "Previous Step",
    "amend": "Modify",
    "addroles": "Add Roles",
    "addprogram": "Add Program",
    "close": "Close",
    "updata": "Upload",
    "open": "Open",
    "Traffic_statistics": "Traffic Statistics",
    "Broadcast_statistics": "Broadcast Statistics",
    paste: "Paste"
  },
  "communal": {
    "placeholder": "Please enter content",
    "zwsj": "No data available",
    "name": "Name",
    "describe": "Description"
  },
  "tip": {
    "tip": "Tip",
    "warmprompt": "Warm Prompt: This function can only be used in a local area network. Public network users, please do not use this function!",
    "a": "The interval between power on and off must be greater than five minutes",
    "b": "The maximum number of downloads is recommended to be less than 70",
    "b1": "The maximum number of downloads is recommended to be less than 150",
    "b2": "The maximum number of downloads is recommended to be less than 200",
    "c": "The maximum download speed is recommended to be less than 200kb",
    "c1": "The maximum download speed is recommended to be less than 500kb",
    "c2": "The maximum download speed is recommended to be less than 1000kb",
    "c3": "The maximum download speed is recommended to be less than 2000kb",
    "c4": "The maximum download speed is recommended to be less than 5000kb",
    "d": "Document upload instructions",
    "e": "Please click the export button to back up the database before updating the version",
    "f": "After updating the version, re-enter this page of the release system and click the import button to select the file exported by the above export button",
    "g": "Tip: Export server runtime error log",
    "h": "(Server location modification, device end not synchronized, please be aware)",
    "j": "The image will be compressed to < 1920 > pixels",
    "k": "If this function is turned off, the number and time of programs will not be counted",
    "z": "Please enter a number greater than 30",
    "cczjsc": "This data will be permanently deleted. Do you want to continue?",
    "qddc": "Confirm export?",
    "successfully": "Saved successfully",
    "tjcg": "Added successfully",
    "xgcg": "Modified successfully",
    "fscg": "Sent successfully",
    "sccg": "Deleted successfully",
    "i": "Unbound program materials will be deleted",
    "o": "Do you want to export?",
    "l": "Program deletion (This program is bound to the following tasks, confirm to permanently delete the program and tasks!)",
    "m": "Confirm to clear scheduled power on/off",
    "n": "Cancelled",
    "p": "Confirm deletion?",
    "q": "Confirm modification?",
    "deletefailed": "Deletion failed",
    "editch": "Edited successfully",
    "editsb": "Editing failed",
    "xzwj": "Please select the upgrade file",
    "ygwj": "Only one file can be selected",
    "imgv": "Please enter the correct system version number for the img file",
    "iimgv": "Please enter the system version number for the img file",
    "zipv": "Please enter the system version number for the zip file",
    "sjsb": "Confirm to upgrade the device",
    "znsck": "Only empty folders can be deleted",
    "sybz": "Insufficient remaining space",
    "aa": "The task name must be between 2 and 50 characters",
    "bb": "The end date of the task cannot be earlier than the start date",
    "cc": "The end time of the task cannot be earlier than the start time",
    "dd": "The end time of the task cannot be the same as the start time",
    "ee": "The end time of the task cannot be earlier than the current time",
    "ff": "The task cycle cannot be empty",
    "gg": "Please select a program to bind",
    "hh": "Please add a program to Screen 1",
    "jj": "Please add a program to Screen 2",
    "beh": "The version number can only be numeric",
    "oned": "Only one device can be selected",
    "srpz": "Please enter a phone number or account",
    "gecw": "The username format is incorrect",
    "wurew": "There are currently no tasks",
    "qdqc": "Confirm to clear, do you want to continue?",
    "qddefbl": "Do you want to delete this resolution?",
    "qddesce": "Do you want to delete this scene?",
    "ll": "File name is duplicated, do you want to replace the duplicate file?",
    "qq": "Confirm to modify the current status?",
    "ww": "Export etv-ip.txt to the root directory of the USB drive, plug it into the device to modify the server information",
    "xx": "ps: Clear all unused materials and tasks before the current date",
    "sjbn": "The time cannot be less than 3 seconds",
    "ztxyzg": "The font needs sufficient spacing",
    "nameim": "Name/Company name cannot be empty",
    "seletTime": "Please select a valid date",
    "sqts": "The number of authorized devices must be greater than 0",
    "cgsyts": "Exceeds the remaining number of devices",
    "bnxy": "Cannot be less than the authorized number of devices",
    "bnxyrl": "Cannot be less than the used capacity",
    "cgsy": "Exceeds the remaining capacity",
    "frqrl": "The server capacity input is too large",
    "selekkh": "Please select the customer to delete",
    "delekh": "Only the next level customer can be deleted",
    tip_copy: "Copy successful",
  },
  "msg": {
    "qxzsb": "Please select a device",
    "qxzsc": "Please select material",
    "phoneisenu": "Phone number cannot be empty"
  },

  "common": {
    "state": "State",
    "cmmfz": "Rename Group",
    "cmmsb": "Rename Device",
    "keyword": "Keyword"
  },
  "placeholder": {
    "qsrfzmc": "Please enter group name",
    "qsrszz": "Please enter a numeric value",
    "bzq": "Phone number format is incorrect, please enter an 11-digit phone number",
    "qqrwz": "Please enter a URL",
    "qsrjmm": "Please enter the old password",
    "qsrsbid": "Please enter device ID",
    "qsrgjz": "Please enter a keyword",
    "qsrheight": "Please enter the correct height",
    "qsrwidth": "Please enter the correct width",
    "qsrbs": "Please enter a multiple of 100",
    "qsrz": "Please enter a value between -1 and 999999",
    "qsraddr": "Please enter an address",
    "qsrbm": "Please enter the package name",
    "qsrbh": "Please enter the device number",
    "qsrmm": "Please enter an 8-character password containing numbers, letters, and special characters",
    "lcmmbyz": "The passwords entered do not match",
    "qxzcer": "Please select a start date",
    "qxzend": "Please select an end date",
    "qxztime": "Please select an end time",
    "qxzendtime": "Please select a start time",
    "a": "The entered capacity cannot be less than the used capacity",
    "b": "The entered value is too large",
    "qxzrwfz": "Please select a task group",
    "qxz": "Please select",
    "qxzjmfl": "Please select a program category",
    "qxzjm": "Please select a program",
    "qxzrw": "Please select a task",
    "qxzfbl": "Please select a resolution",
    "qxzhdqy": "Please select an activity area",
    "qxzwzsj": "Please select a complete time period",
    "qxzysc": "Please select the file to delete",
    "qxzfile": "Please select a file"
  },
  "codekey": {
    "err": "Verification code error"
  },
  "nav": {
    "image": "Image",
    "video": "Video",
    "audio": "Audio",
    "mixture": "Mixed Broadcast",
    "date": "Date",
    "weeks": "Weeks",
    "countDown": "Countdown",
    "time": "Time",
    "weather": "Weather",
    "subtitle": "Subtitle",
    "webPage": "Web Page",
    "doc": "Document",
    "streaming": "Streaming",
    "button": "Button",
    "area": "Area",
    "hdmin": "HDMI In"
  },
  "settimg": {
    "fontColor": "Font Color",
    "bgColor": "Background Color",
    "fontSize": "Font Size",
    "direction": "Scroll Direction",
    "speed": "Scroll Speed",
    "city": "Select City",
    "effect": "Transition Effect",
    "uniformly": "Uniformly Set Transition Time",
    "time": "Interval",
    "text": "Subtitle Content",
    "aligning": "Alignment",
    "nodes": "Time Nodes",
    "unit": "Unit",
    "DXVA": "Hardware Acceleration",
    "isopen": "Enable",
    "address": "Add Address",
    "btnFont": "Button Text",
    "interact": "Interact",
    "still": "Still",
    "ms": "Slow",
    "zs": "Medium",
    "ks": "Fast",
    "bt": "Bottom to Top",
    "lr": "Left to Right",
    "rl": "Right to Left",
    "dwxs": "Unit Display",
    "font": "Font",
    "unity": "Uniformly Set Volume",
    "no_trigger": "No Trigger",
    "scene_jump": "Scene Jump",
    "website": "Third Party Website",
    "preview": "Fullscreen Preview",
    "APK": "Third Party APK",
    "select": "Select Scene",
    "addweb": "Add Website",
    "addpacket": "Add APK Package",
    "volume": "Video Volume",
    "Switching": "Switching Time",
    "back": "Touch Return",
    "noback": "No Return",
    "return": "Return",
    "stretch": "Image and video will be stretched"
  },
  "edit_pass": {
    "account_center": "Account Security Center",
    "password_management": "Password Management",
    "enter_password": "Enter New Password",
    "ps1": "The current password is too simple. To protect your account security, please change your password as soon as possible.",
    "please_new_password": "Please enter the new password you want to set",
    "submit": "Submit",
    "ps": "Please enter an 8-character password containing letters, numbers, and special English characters from '~@#$%^&+=!()*'",
    "ps2": "The current password has not been updated for a long time. To protect your account security, please change your password as soon as possible."
  },
  append_field:{
    allDayText: 'All Day',
    weekPlan: 'Week Plan',
    dayPlan: 'Day Plan',
    addProgramPlan: 'Add program plan',
    selectProgram: 'Please select program',
    selectTaskCycle: 'Please select task cycle',
    selectPlanTimeRange: 'Please select plan time range',
    editProgramPlan: 'Edit program plan',
    startTimeError: 'Start time cannot be later than or equal to end time',
    maxProgramPlans: 'You can create up to 17 program plans per day',
    noCoexistTasks: 'Tasks cannot coexist between week view and day view',
    overlappingPlans: 'Plan or plan time overlaps, cannot create plan',
    closePlan: 'Close plan',
    enablePlan: 'Enable plan',
    planIsEmpty: 'Plan is empty',
    login_background: 'Login Background',
    login_carousel: 'Carousel',
    logo: 'Logo Settings',
    title: 'Title',
    tip_swiper_list: 'You can upload up to 6 carousel images. Please reselect.',
    tip_size: 'Recommended upload size: 867*611',
    tip_del_logo: 'Cannot delete the default image',
    default_mode: 'Default Mode',
    default_mode_description: 'After setting to default mode, the device will automatically download this program when connected to the server',
    apk_version: 'Effective for APK version 7.0.0.7 and above',
    plan_settings: 'Plan Settings',
    plan_mode: 'Plan Mode',
    edit_plan_settings: 'Edit Plan Settings',
    add_program_info: 'Please add program information',
    reset_plan: 'Reset Plan',
    confirm_reset_plan: 'Do you want to reset the current plan?',
    ai_customer_service: 'AI Customer Service ',
    guess_you_want_to_ask: 'Guess you want to ask?',
    search_time: 'Search Time',
    output_time: 'Output Time',
    total_calls: 'Total Calls',
    thinking: 'Thinking',
    clear_chat: 'Clear Chat',
    scroll_to_bottom: 'Scroll to Bottom',
    input_your_question_here: 'Input your question here, Enter to send, Ctrl+Enter for new line',
    how_to_use_etv: 'How to use ETV?',
    how_to_upload_material_to_etv: 'How to upload material to ETV?',
    how_to_issue_program_on_etv: 'How to issue program on ETV?',
    how_to_add_user_to_etv: 'How to add user to ETV?',
    ai_server_not_responding: 'AI server not responding, please try again later.',
    waking_up: 'Waking up, please wait!',
    no_available_key: 'No available key. Please use the AI window in another tab, or log out and log in again.',
    expand_layer: 'Expand layer',
    collapse_layer: 'Collapse layer',
    smart_assistant: 'Smart Assistant',
    download_resources: 'Download Resources',

  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js